import {Injectable} from '@angular/core';
import {SocketServices} from '../../CoreModule/services/socket.services';
import {Observable} from 'rxjs';
import {getLoginUser} from '../../CoreModule/services/usuario.services';

@Injectable()
export class InventarioServices {

  public obsSendInvXCat: Observable<any>;
  public obsSendProdDescXPrecio: Observable<any>;
  public obsSendInvProdXPrecio: Observable<any>;

  constructor(private ss: SocketServices) {
    this.obsSendInvXCat = this.ss.registrarEvento('sendInvXCat');
    this.obsSendProdDescXPrecio = this.ss.registrarEvento('setProdDescXPrecio');
    this.obsSendInvProdXPrecio = this.ss.registrarEvento('sendInvXPrecioVenta');
  }

  getInvXCat(entidad: any, idEntidad: any, fecha: any) {
    this.ss.enviarEvento('getInvXCat', {entidad: entidad, idEntidad: idEntidad, idUser: getLoginUser(), fecha: fecha});
  }

  getProdDescXPrecio(entidad: any, idEntidad: any){
    this.ss.enviarEvento('getProdDescXPrecio', {entidad: entidad, idEntidad: idEntidad, idUser: getLoginUser()});
  }

  getInvXPrecioVenta(entidad: any, idEntidad: any){
    this.ss.enviarEvento('getInvXPrecioVenta', {entidad: entidad, idEntidad: idEntidad, idUser: getLoginUser()});
  }


}
